// Centralized links and copy constants used across pages.
export const AMAZON_URL =
  "https://www.amazon.in/Nothing-Way-Memoir-Rahul-Bhaskar-ebook/dp/B0GMSWC7G4/ref=sr_1_1?crid=21CWPUAZMZXGL&dib=eyJ2IjoiMSJ9.3gsgJ8FhyXQVitOkdduAOQ.agTRSV5i2ilFvSyK8VPdFBfGxkgrXyVIehYdr-cLS34&dib_tag=se&keywords=nothing+in+the+way+rahul+bhaskar&qid=1778226880&sprefix=nothing+in+the+way+rahul+bhask%2Caps%2C394&sr=8-1";

// Kindle is the same listing on Amazon India (it's a Kindle ebook).
export const KINDLE_URL = AMAZON_URL;

export const EMAILS = {
  general: "hello@nothinginthewaybook.com",
  press: "press@nothinginthewaybook.com",
  bookclubs: "bookclubs@nothinginthewaybook.com",
  events: "events@nothinginthewaybook.com",
};
